export default __webpack_public_path__ + "static/media/keerthana.30adc539.jpg";